(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ei-apparel-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(carousel) {
      var track = carousel.querySelector('.ei-carousel__track');
      var btnPrev = carousel.querySelector('.ei-carousel__btn--prev');
      var btnNext = carousel.querySelector('.ei-carousel__btn--next');
      if (!track) return;

      function update() {
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (btnPrev) btnPrev.disabled = atStart;
        if (btnNext) btnNext.disabled = atEnd;
      }

      function scrollBy(dir) {
        track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
      }

      track.addEventListener('scroll', update, { passive: true });
      if (btnPrev) btnPrev.addEventListener('click', function () { scrollBy(-1); });
      if (btnNext) btnNext.addEventListener('click', function () { scrollBy(1); });
      update();
    }

    document.querySelectorAll('[data-apparel-carousel]').forEach(initCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ei-apparel-showroom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-asr-swim]').forEach(function (section) {
      var track = section.querySelector('.asr__swim-track');
      var prevBtn = section.querySelector('[data-asr-prev]');
      var nextBtn = section.querySelector('[data-asr-next]');
      if (!track) return;

      function updateBtns() {
        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 2;
        if (nextBtn) nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      track.addEventListener('scroll', updateBtns, { passive: true });

      if (prevBtn) prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      });

      updateBtns();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ei-cart"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    function updateCartItem(key, qty) {
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function() {
        window.location.reload();
      });
    }

    document.querySelectorAll('[data-qty-minus], [data-qty-plus]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var stepper = this.closest('.ei-cart__qty-stepper');
        var input = stepper.querySelector('.ei-cart__qty-input');
        if (!input) return;
        var key = input.dataset.key;
        var val = parseInt(input.value, 10);
        var newVal;
        if (this.hasAttribute('data-qty-minus')) {
          newVal = Math.max(0, val - 1);
        } else {
          newVal = val + 1;
        }
        input.value = newVal;
        updateCartItem(key, newVal);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ei-coll-barware"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* scroll reveal */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('[data-bw-reveal]').forEach(function (el) {
      observer.observe(el);
    });

    /* thumbnail click: swap visible image */
    document.querySelectorAll('.bw__band-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var band = thumb.closest('[data-bw-band]');
        if (!band) return;
        var idx = parseInt(thumb.dataset.thumbIndex, 10);
        var imgs = band.querySelectorAll('.bw__band-mainimg');
        var thumbs = band.querySelectorAll('.bw__band-thumb');

        imgs.forEach(function (img) {
          img.style.opacity = parseInt(img.dataset.imgIndex, 10) === idx ? '1' : '0';
        });
        thumbs.forEach(function (t) {
          if (parseInt(t.dataset.thumbIndex, 10) === idx) {
            t.classList.add('is-active');
          } else {
            t.classList.remove('is-active');
          }
        });

        /* mark as user-selected so scroll crossfade doesn't override */
        band.dataset.userSelected = 'true';
      });
    });

    /* scroll: parallax + crossfade to 2nd image on exit + counter */
    var bandImgWrappers = document.querySelectorAll('.bw__band-img');
    var counter = document.querySelector('[data-bw-counter]');
    var bandEls = document.querySelectorAll('[data-bw-band]');
    var total = bandEls.length;
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var vh = window.innerHeight;

          bandEls.forEach(function (band, i) {
            var rect = band.getBoundingClientRect();
            if (rect.top >= vh || rect.bottom <= 0) return;

            /* parallax on the active main image */
            var imgWrap = band.querySelector('.bw__band-img');
            if (imgWrap) {
              var progress = (vh - rect.top) / (vh + rect.height);
              var shift = (progress - 0.5) * 30;
              var activeImg = imgWrap.querySelector('.bw__band-mainimg[style*="opacity: 1"], .bw__band-mainimg[style*="opacity:1"]');
              if (activeImg) activeImg.style.transform = 'translateY(' + shift + 'px)';
            }

            /* crossfade to 2nd image as band scrolls out (unless user selected a thumb) */
            if (band.dataset.userSelected !== 'true') {
              var imgs = band.querySelectorAll('.bw__band-mainimg');
              if (imgs.length > 1) {
                var exitProgress = Math.max(0, Math.min(1, -rect.top / rect.height));
                if (exitProgress > 0.3) {
                  var fadeAmt = Math.min(1, (exitProgress - 0.3) / 0.4);
                  imgs[0].style.opacity = String(1 - fadeAmt);
                  imgs[1].style.opacity = String(fadeAmt);
                } else {
                  imgs[0].style.opacity = '1';
                  imgs[1].style.opacity = '0';
                }
              }
            }
          });

          /* floating counter */
          if (counter && total > 0) {
            var current = 0;
            var mid = vh * 0.5;
            bandEls.forEach(function (b, i) {
              if (b.getBoundingClientRect().top < mid) current = i + 1;
            });
            if (current > 0 && current <= total) {
              counter.textContent = current + ' / ' + total;
              counter.classList.add('is-visible');
            } else {
              counter.classList.remove('is-visible');
            }
          }

          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ei-coll-glassware"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var hero = document.querySelector('[data-gw-hero]');
    var film = document.querySelector('[data-gw-film]');
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    function clamp(v, min, max) {
      return Math.max(min, Math.min(max, v));
    }

    function onScroll() {
      /* ── Hero: fade title, scale up product ── */
      if (hero) {
        var hRect = hero.getBoundingClientRect();
        var hTravel = hero.offsetHeight - window.innerHeight;
        var hp = clamp(-hRect.top / hTravel, 0, 1);

        var title = hero.querySelector('.gw__hero-title');
        var eyebrow = hero.querySelector('.gw__hero-eyebrow');
        var desc = hero.querySelector('.gw__hero-desc');
        var scroll = hero.querySelector('.gw__hero-scroll');
        var prodImg = hero.querySelector('.gw__hero-product');

        if (title) {
          title.style.opacity = String(1 - hp * 1.8);
          title.style.transform = 'scale(' + (1 - hp * 0.12) + ') translateY(' + (-hp * 50) + 'px)';
        }
        if (eyebrow) eyebrow.style.opacity = String(1 - hp * 2.5);
        if (desc) desc.style.opacity = String(1 - hp * 2.5);
        if (scroll) scroll.style.opacity = String(0.4 * (1 - hp * 4));
        if (prodImg) {
          var s = 0.6 + hp * 1.4;
          prodImg.style.opacity = String(hp * 1.5);
          prodImg.style.transform = 'translate(-50%, -50%) scale(' + s + ')';
        }
      }

      /* ── Filmstrip: crossfade products ── */
      if (film) {
        var fRect = film.getBoundingClientRect();
        var fTravel = film.offsetHeight - window.innerHeight;
        var fp = clamp(-fRect.top / fTravel, 0, 0.9999);
        var total = parseInt(film.dataset.total, 10);

        var activeIdx = Math.floor(fp * total);
        var slideProg = (fp * total) - activeIdx;

        var slides = film.querySelectorAll('.gw__film-slide');
        slides.forEach(function (slide, i) {
          var img = slide.querySelector('.gw__film-slide-img');
          var info = slide.querySelector('.gw__film-slide-info');

          if (i === activeIdx) {
            slide.style.opacity = '1';
            slide.style.zIndex = '2';
            if (img) {
              var scale = 0.88 + slideProg * 0.12;
              img.style.transform = 'scale(' + Math.min(scale, 1) + ')';
            }
            if (info) {
              var op = clamp(slideProg * 4, 0, 1);
              info.style.opacity = String(op);
              info.style.transform = 'translateY(' + ((1 - op) * 24) + 'px)';
            }
          } else if (i === activeIdx - 1) {
            slide.style.opacity = String(Math.max(0, 1 - slideProg * 2));
            slide.style.zIndex = '1';
            if (img) img.style.transform = 'scale(' + (1 + slideProg * 0.04) + ')';
            if (info) {
              info.style.opacity = String(Math.max(0, 1 - slideProg * 3));
              info.style.transform = 'translateY(' + (-slideProg * 16) + 'px)';
            }
          } else {
            slide.style.opacity = '0';
            slide.style.zIndex = '0';
          }
        });

        /* dots */
        var dots = film.querySelectorAll('.gw__film-dot');
        dots.forEach(function (dot, i) {
          if (i === activeIdx) {
            dot.classList.add('is-active');
          } else {
            dot.classList.remove('is-active');
          }
        });

        /* counter */
        var counter = film.querySelector('[data-gw-current]');
        if (counter) counter.textContent = String(activeIdx + 1);

        /* progress */
        var bar = film.querySelector('.gw__film-progress-bar');
        if (bar) bar.style.transform = 'scaleX(' + fp + ')';
      }
    }

    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ei-coll-hobbies"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var deck = document.querySelector('[data-hb-deck]');
    if (!deck) return;

    var cards = Array.from(deck.querySelectorAll('.hb__card'));
    var total = cards.length;
    var currentIdx = 0;
    var counterEl = document.querySelector('[data-hb-counter]');
    var prevBtn = document.querySelector('[data-hb-prev]');
    var nextBtn = document.querySelector('[data-hb-next]');

    function updateStack() {
      cards.forEach(function (card, i) {
        card.classList.remove('is-dismissed-left', 'is-dismissed-right', 'is-behind');
        card.style.transform = '';
        card.style.opacity = '';
        card.style.zIndex = '';
        card.style.pointerEvents = '';

        var offset = i - currentIdx;

        if (offset < 0) {
          card.style.opacity = '0';
          card.style.pointerEvents = 'none';
          card.style.zIndex = '0';
          card.classList.add('is-behind');
        } else if (offset === 0) {
          card.style.transform = 'scale(1) translateY(0)';
          card.style.opacity = '1';
          card.style.zIndex = '10';
        } else if (offset === 1) {
          card.style.transform = 'scale(0.96) translateY(10px)';
          card.style.opacity = '1';
          card.style.zIndex = '9';
          card.classList.add('is-behind');
        } else if (offset === 2) {
          card.style.transform = 'scale(0.92) translateY(20px)';
          card.style.opacity = '0.7';
          card.style.zIndex = '8';
          card.classList.add('is-behind');
        } else {
          card.style.opacity = '0';
          card.style.pointerEvents = 'none';
          card.style.zIndex = '0';
          card.classList.add('is-behind');
        }
      });

      if (counterEl) counterEl.textContent = (currentIdx + 1) + ' / ' + total;
      if (prevBtn) prevBtn.disabled = currentIdx <= 0;
      if (nextBtn) nextBtn.disabled = currentIdx >= total - 1;
    }

    function dismissRight() {
      if (currentIdx >= total - 1) return;
      var card = cards[currentIdx];
      card.classList.add('is-dismissed-left');
      card.style.zIndex = '5';
      currentIdx++;
      setTimeout(updateStack, 100);
    }

    function bringBack() {
      if (currentIdx <= 0) return;
      currentIdx--;
      var card = cards[currentIdx];
      card.classList.remove('is-dismissed-left', 'is-dismissed-right');
      updateStack();
    }

    if (nextBtn) nextBtn.addEventListener('click', dismissRight);
    if (prevBtn) prevBtn.addEventListener('click', bringBack);

    /* thumbnail clicks inside cards */
    deck.addEventListener('click', function (e) {
      var thumb = e.target.closest('.hb__card-thumb');
      if (!thumb) return;
      e.preventDefault();
      e.stopPropagation();
      var card = thumb.closest('.hb__card');
      if (!card) return;
      var idx = parseInt(thumb.dataset.thumbIdx, 10);
      var imgs = card.querySelectorAll('.hb__card-mainimg');
      var thumbs = card.querySelectorAll('.hb__card-thumb');
      imgs.forEach(function (img) {
        img.style.opacity = parseInt(img.dataset.imgIdx, 10) === idx ? '1' : '0';
      });
      thumbs.forEach(function (t) {
        if (parseInt(t.dataset.thumbIdx, 10) === idx) {
          t.classList.add('is-active');
        } else {
          t.classList.remove('is-active');
        }
      });
    });

    /* swipe support */
    var startX = 0;
    var dragging = false;

    deck.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.hb__card-thumb') || e.target.closest('.hb__card-btn')) return;
      startX = e.clientX;
      dragging = true;
    });

    deck.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false;
      var diff = e.clientX - startX;
      if (diff < -60) dismissRight();
      if (diff > 60) bringBack();
    });

    updateStack();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ei-coll-kitchenware"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var hero = document.querySelector('[data-kw-hero]');
    var hscroll = document.querySelector('[data-kw-hscroll]');
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

    function onScroll() {
      /* ── Hero: fade + scale ── */
      if (hero) {
        var hRect = hero.getBoundingClientRect();
        var hTravel = hero.offsetHeight - window.innerHeight;
        var hp = clamp(-hRect.top / hTravel, 0, 1);

        var title = hero.querySelector('.kw__hero-title');
        var eyebrow = hero.querySelector('.kw__hero-eyebrow');
        var desc = hero.querySelector('.kw__hero-desc');
        var scroll = hero.querySelector('.kw__hero-scroll');

        if (title) {
          title.style.opacity = String(1 - hp * 1.8);
          title.style.transform = 'scale(' + (1 - hp * 0.12) + ') translateY(' + (-hp * 50) + 'px)';
        }
        if (eyebrow) eyebrow.style.opacity = String(1 - hp * 2.5);
        if (desc) desc.style.opacity = String(1 - hp * 2.5);
        if (scroll) scroll.style.opacity = String(0.4 * (1 - hp * 4));
      }

      /* ── Horizontal scroll ── */
      if (hscroll) {
        var track = hscroll.querySelector('.kw__hscroll-track');
        var panels = hscroll.querySelectorAll('.kw__panel');
        var total = panels.length;
        if (!track || total === 0) return;

        var sRect = hscroll.getBoundingClientRect();
        var sTravel = hscroll.offsetHeight - window.innerHeight;
        var sp = clamp(-sRect.top / sTravel, 0, 1);

        /* move track horizontally */
        var maxShift = (total - 1) * 100;
        track.style.transform = 'translateX(-' + (sp * maxShift) + 'vw)';

        /* active pip */
        var activeIdx = Math.min(Math.floor(sp * total), total - 1);
        var pips = hscroll.querySelectorAll('.kw__hscroll-pip');
        pips.forEach(function (pip, i) {
          if (i === activeIdx) {
            pip.classList.add('is-active');
          } else {
            pip.classList.remove('is-active');
          }
        });

        /* counter */
        var counter = hscroll.querySelector('[data-kw-current]');
        if (counter) counter.textContent = String(activeIdx + 1);

        /* nav button states */
        var prevBtn = hscroll.querySelector('[data-kw-prev]');
        var nextBtn = hscroll.querySelector('[data-kw-next]');
        if (prevBtn) prevBtn.disabled = activeIdx <= 0;
        if (nextBtn) nextBtn.disabled = activeIdx >= total - 1;
      }
    }

    onScroll();

    /* ── Nav button clicks: snap to exact panel positions ── */
    if (hscroll) {
      var totalPanels = hscroll.querySelectorAll('.kw__panel').length;

      function getCurrentIdx() {
        var travel = hscroll.offsetHeight - window.innerHeight;
        var scrolled = window.scrollY - hscroll.offsetTop;
        var progress = clamp(scrolled / travel, 0, 1);
        return progress * (totalPanels - 1);
      }

      function goToPanel(idx) {
        idx = clamp(idx, 0, totalPanels - 1);
        var travel = hscroll.offsetHeight - window.innerHeight;
        var frac = totalPanels > 1 ? idx / (totalPanels - 1) : 0;
        var targetScroll = hscroll.offsetTop + frac * travel;
        window.scrollTo({ top: targetScroll, behavior: 'smooth' });
      }

      var prevBtn = hscroll.querySelector('[data-kw-prev]');
      var nextBtn = hscroll.querySelector('[data-kw-next]');

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goToPanel(Math.round(getCurrentIdx()) - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goToPanel(Math.round(getCurrentIdx()) + 1);
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ei-coll-mugs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' });

    document.querySelectorAll('[data-mg-reveal]').forEach(function (el) {
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ei-coll-stationery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var indexItems = document.querySelectorAll('[data-st-index]');
    var panels = document.querySelectorAll('[data-st-panel]');
    if (!indexItems.length || !panels.length) return;

    var currentIdx = 0;

    function activate(idx) {
      currentIdx = idx;
      indexItems.forEach(function (item, i) {
        if (i === idx) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });
      panels.forEach(function (panel, i) {
        if (i === idx) {
          panel.classList.add('is-active');
        } else {
          panel.classList.remove('is-active');
        }
      });
    }

    indexItems.forEach(function (item, i) {
      item.addEventListener('click', function () { activate(i); });
      item.addEventListener('mouseenter', function () { activate(i); });
    });

    /* thumbnail clicks */
    document.querySelectorAll('.st__showcase-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var panel = thumb.closest('[data-st-panel]');
        if (!panel) return;
        var idx = parseInt(thumb.dataset.thumbIdx, 10);
        var imgs = panel.querySelectorAll('.st__showcase-mainimg');
        var thumbs = panel.querySelectorAll('.st__showcase-thumb');
        imgs.forEach(function (img) {
          img.style.opacity = parseInt(img.dataset.imgIdx, 10) === idx ? '1' : '0';
        });
        thumbs.forEach(function (t) {
          if (parseInt(t.dataset.thumbIdx, 10) === idx) {
            t.classList.add('is-active');
          } else {
            t.classList.remove('is-active');
          }
        });
      });
    });

    /* keyboard nav */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
        e.preventDefault();
        activate(Math.min(currentIdx + 1, panels.length - 1));
      }
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
        e.preventDefault();
        activate(Math.max(currentIdx - 1, 0));
      }
    });

    activate(0);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ei-coll-tools"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

    document.querySelectorAll('[data-tl-reveal]').forEach(function (el) {
      observer.observe(el);
    });

    /* parallax on feature images */
    var features = document.querySelectorAll('.tl__feature-img');
    var ticking = false;

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          var vh = window.innerHeight;
          features.forEach(function (wrap) {
            var rect = wrap.getBoundingClientRect();
            if (rect.top < vh && rect.bottom > 0) {
              var progress = (vh - rect.top) / (vh + rect.height);
              var shift = (progress - 0.5) * 30;
              var img = wrap.querySelector('.tl__feature-mainimg[style*="opacity:1"], .tl__feature-mainimg[style*="opacity: 1"]');
              if (img) img.style.transform = 'translateY(' + shift + 'px)';
            }
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    /* thumbnail clicks */
    document.querySelectorAll('[data-tl-gallery]').forEach(function (gallery) {
      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-thumb-idx]');
        if (!thumb) return;
        e.preventDefault();
        e.stopPropagation();
        var idx = parseInt(thumb.dataset.thumbIdx, 10);
        var imgs = gallery.querySelectorAll('[data-img-idx]');
        var thumbs = gallery.querySelectorAll('[data-thumb-idx]');
        imgs.forEach(function (img) {
          img.style.opacity = parseInt(img.dataset.imgIdx, 10) === idx ? '1' : '0';
        });
        thumbs.forEach(function (t) {
          if (parseInt(t.dataset.thumbIdx, 10) === idx) {
            t.classList.add('is-active');
          } else {
            t.classList.remove('is-active');
          }
        });
      });
    });

    /* 3D tilt on grid cards */
    document.querySelectorAll('.tl__card-img').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'perspective(500px) rotateY(' + (x * 5) + 'deg) rotateX(' + (-y * 5) + 'deg)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ei-gift-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Scroll reveal via IntersectionObserver */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('[data-gc-reveal]').forEach(function (el) {
      observer.observe(el);
    });

    /* Parallax on hero background */
    var heroBg = document.querySelector('.ei-gc__hero-bg');
    if (heroBg) {
      var hero = heroBg.parentElement;
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            var rect = hero.getBoundingClientRect();
            var visible = rect.top < window.innerHeight && rect.bottom > 0;
            if (visible) {
              var scrolled = -rect.top;
              heroBg.style.transform = 'translateY(' + (scrolled * 0.25) + 'px) scale(1.05)';
            }
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ei-product-b2b"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var t1Min = 24, t2Min = 50, t3Min = 100;
    var root = document.querySelector('.ei-b2b');
    var t1Price = root ? parseFloat(root.dataset.tier1Price) || 72 : 72;
    var t2Price = root ? parseFloat(root.dataset.tier2Price) || 64 : 64;
    var t3Price = root ? parseFloat(root.dataset.tier3Price) || 55 : 55;

    function updateTotals() {
      var totalQty = 0;
      document.querySelectorAll('[data-color-row]').forEach(function(row) {
        var rowQty = 0;
        row.querySelectorAll('[data-qty-cell]').forEach(function(input) {
          rowQty += parseInt(input.value, 10) || 0;
        });
        totalQty += rowQty;
        var qtyCell = row.querySelector('[data-row-total]');
        var priceCell = row.querySelector('[data-row-price]');
        if (qtyCell) qtyCell.textContent = rowQty > 0 ? rowQty + ' units' : '';
        if (priceCell) {
          if (rowQty > 0) {
            var rowUnitPrice = totalQty >= t3Min ? t3Price : totalQty >= t2Min ? t2Price : t1Price;
            priceCell.textContent = '$' + (rowQty * rowUnitPrice).toFixed(2);
          } else {
            priceCell.textContent = '—';
          }
        }
      });

      var unitPrice = totalQty >= t3Min ? t3Price : totalQty >= t2Min ? t2Price : t1Price;
      var total = (totalQty * unitPrice).toFixed(2);

      var qtyEl = document.getElementById('ei-b2b-total-qty');
      var tierEl = document.getElementById('ei-b2b-tier-label');
      var priceEl = document.getElementById('ei-b2b-total-price');

      if (qtyEl) qtyEl.textContent = totalQty + ' Units';
      if (priceEl) priceEl.textContent = '$' + total;
      if (tierEl) {
        var tier = totalQty >= t3Min ? '3' : totalQty >= t2Min ? '2' : '1';
        tierEl.innerHTML = 'Tier ' + tier + ' <span style="font-size:0.75rem;font-weight:400;color:var(--ei-on-surface-variant);">($' + unitPrice.toFixed(2) + '/unit)</span>';
      }
    }

    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('[data-qty-cell]').forEach(function(input) {
        input.addEventListener('input', updateTotals);
      });

      // Thumbnail gallery swap
      var mainImg = document.getElementById('ei-b2b-main-img');
      document.querySelectorAll('[data-thumb]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (mainImg) mainImg.src = btn.dataset.src;
          document.querySelectorAll('[data-thumb]').forEach(function(b) {
            b.classList.remove('ei-b2b__thumb--active');
          });
          btn.classList.add('ei-b2b__thumb--active');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ei-product-gift"] && !Shopify.designMode) return;
  try {
    
  /* Ship-blank checkbox: when checked, clear and lock the visual customizer.
     The customizer dispatches `ei:engraving-saved`; we drop that state and
     disable the trigger button. Unchecking unlocks. */
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-ship-blank]').forEach(function(cb) {
      cb.addEventListener('change', function() {
        var customizer = document.querySelector('engraving-customizer-v2');
        var trigger = customizer ? customizer.querySelector('[data-trigger]') : null;
        var notesField = document.querySelector('[data-custom-design-notes]');
        if (cb.checked) {
          /* Wipe any saved design state so it doesn't get attached on submit */
          window.__EI_ENGRAVING__ = null;
          if (customizer && typeof customizer.clearCanvas === 'function') {
            try { customizer.clearCanvas(); } catch (e) { /* customizer may not be ready yet */ }
          }
          if (trigger) {
            trigger.disabled = true;
            trigger.classList.add('is-locked');
          }
          if (notesField) notesField.disabled = true;
        } else {
          if (trigger) {
            trigger.disabled = false;
            trigger.classList.remove('is-locked');
          }
          if (notesField) notesField.disabled = false;
        }
      });
    });
  });

  /* Inspiration image uploads (no-blank designer flow). Files are uploaded
     to Shopify Files via the cart-upload variant trick (same pattern as the
     customizer's design files), and their CDN URLs are stashed on
     `window.__EI_INSPIRATION__` keyed by form scope. The submit handler reads
     this and populates the hidden _Inspiration N inputs. */
  window.__EI_INSPIRATION__ = window.__EI_INSPIRATION__ || {};
  window.__EI_INSPIRATION_PENDING__ = null;

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-inspiration-uploads]').forEach(function(input) {
      var listEl = input.parentNode.querySelector('[data-inspiration-list]');
      var formEl = input.closest('form');
      var scopeKey = formEl ? (formEl.dataset.engraveScope = formEl.dataset.engraveScope || ('insp-' + Math.random().toString(36).slice(2, 9))) : 'default';
      window.__EI_INSPIRATION__[scopeKey] = window.__EI_INSPIRATION__[scopeKey] || [];

      input.addEventListener('change', async function(e) {
        var files = Array.from(e.target.files || []).slice(0, 5);
        e.target.value = '';
        var uploads = files.map(async function(file) {
          if (file.size > 5 * 1024 * 1024) {
            renderInspItem(listEl, file.name, null, 'too large (max 5 MB)');
            return null;
          }
          var rowEl = renderInspItem(listEl, file.name, null, 'uploading…');
          try {
            var url = await uploadInspiration(file);
            window.__EI_INSPIRATION__[scopeKey] = window.__EI_INSPIRATION__[scopeKey].concat([url]).slice(0, 5);
            rowEl.querySelector('[data-status]').textContent = 'uploaded';
            rowEl.querySelector('[data-status]').className = 'ok';
            return url;
          } catch (err) {
            rowEl.querySelector('[data-status]').textContent = 'failed: ' + err.message;
            rowEl.querySelector('[data-status]').className = 'err';
            return null;
          }
        });
        window.__EI_INSPIRATION_PENDING__ = Promise.all(uploads);
        await window.__EI_INSPIRATION_PENDING__;
      });
    });
  });

  function renderInspItem(listEl, name, _url, status) {
    if (!listEl) return document.createElement('div');
    var row = document.createElement('div');
    row.className = 'ei-engrave-insp-item';
    row.innerHTML =
      '<span class="name">' + (name || 'image').replace(/[<>&]/g, function(c){return c==='<'?'&lt;':c==='>'?'&gt;':'&amp;';}) + '</span>' +
      '<span class="ok" data-status>' + status + '</span>';
    listEl.appendChild(row);
    return row;
  }

  /* Cart-upload trick: add a special variant to cart with the file as a line
     item property, harvest the resulting CDN URL, then remove that throwaway
     line. Reuses the customizer's `customizer_upload_variant_id` setting. */
  async function uploadInspiration(file) {
    var settings = (typeof __EI_THEME_SETTINGS__ !== 'undefined') ? __EI_THEME_SETTINGS__ : {};
    var uploadVariantId = (window.__EI_UPLOAD_VARIANT_ID__) || (document.querySelector('engraving-customizer-v2')?.dataset?.uploadVariantId);
    if (!uploadVariantId) throw new Error('upload variant not configured');

    var fd = new FormData();
    fd.append('id', uploadVariantId);
    fd.append('quantity', 1);
    fd.append('properties[file]', file);
    fd.append('properties[_temp_inspiration]', '1');

    var res = await fetch('/cart/add.js', { method: 'POST', body: fd });
    if (!res.ok) throw new Error('upload failed (HTTP ' + res.status + ')');
    var data = await res.json();
    var url = data.properties && data.properties.file;
    if (!url) throw new Error('no URL returned');

    /* Remove the throwaway line item */
    try {
      var cart = await fetch('/cart.js').then(function(r){return r.json();});
      var line = cart.items.find(function(i){
        return i.properties && i.properties._temp_inspiration === '1' && i.properties.file === url;
      });
      if (line) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ id: line.key, quantity: 0 }),
        });
      }
    } catch (_) { /* best effort */ }
    return url;
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.ei-product').forEach(function(section) {
      var jsonEl = section.querySelector('.ei-product__variants-json');
      var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      var mainImg = section.querySelector('#ei-product-main-img');
      var priceEl = section.querySelector('.ei-product__price');
      var idInput = section.querySelector('input[name="id"]');
      var addBtn = section.querySelector('.ei-product__add-btn');

      function getSelectedOptions() {
        var selected = {};
        section.querySelectorAll('.ei-product__variant-btn[aria-pressed="true"]').forEach(function(btn) {
          selected[btn.dataset.option] = btn.dataset.value;
        });
        return selected;
      }

      function findVariant(selected) {
        return variants.find(function(v) {
          return v.options.every(function(val, i) {
            var optionKeys = Object.keys(selected);
            return optionKeys[i] === undefined || selected[optionKeys[i]] === val;
          });
        });
      }

      function updateVariant() {
        var selected = getSelectedOptions();
        var variant = findVariant(selected);
        if (!variant) return;

        if (idInput) idInput.value = variant.id;

        if (variant.image && mainImg) {
          mainImg.src = variant.image.src;
          mainImg.alt = variant.image.alt;
        }

        if (priceEl) priceEl.textContent = variant.price;

        if (addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.style.opacity = '';
            addBtn.style.cursor = '';
          } else {
            addBtn.disabled = true;
            addBtn.style.opacity = '0.5';
            addBtn.style.cursor = 'not-allowed';
            addBtn.textContent = 'Sold Out';
          }
        }
      }

      section.querySelectorAll('.ei-product__variant-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          section.querySelectorAll('.ei-product__variant-btn[data-option="' + this.dataset.option + '"]').forEach(function(b) {
            b.removeAttribute('aria-pressed');
          });
          this.setAttribute('aria-pressed', 'true');
          updateVariant();
        });
      });

      section.querySelectorAll('.ei-product__thumb').forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          var fullSrc = thumb.dataset.fullSrc;
          if (fullSrc && mainImg) mainImg.src = fullSrc;
          section.querySelectorAll('.ei-product__thumb').forEach(function(t) {
            t.classList.remove('is-active');
          });
          thumb.classList.add('is-active');
        });
      });
    });
  });

  /* AJAX add-to-cart: intercept form, show drawer with updated content, auto-close */
  document.querySelectorAll('.ei-product__purchase').forEach(function(form) {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();

      /* If user wants to ship blank, force-clear the visual design */
      var shipBlankInput = form.querySelector('[data-ship-blank]');
      var shipBlank = shipBlankInput && shipBlankInput.checked;

      /* Show full-screen blocking overlay for the whole flow (auto-save +
         cart submit + drawer reveal). Hidden in the finally below. */
      var overlay = window.__EI_BLOCKING_OVERLAY__;
      if (overlay) overlay.show('Adding to cart…');

      /* Auto-save any unsaved canvas design before submitting.
         Handles the case where the customer designs something, closes the
         dialog, then clicks Add-to-Cart — without this, the design would be
         lost on submit. Skipped when "Ship Blank" is on. */
      var customizerEl = document.querySelector('engraving-customizer-v2');
      if (!shipBlank && customizerEl && customizerEl.canvas
          && customizerEl.canvas.getObjects().length > 0
          && (!window.__EI_ENGRAVING__ || !window.__EI_ENGRAVING__.designPng)) {
        try {
          await customizerEl.saveDesign();
        } catch (err) {
          console.error('[EI] auto-save before add-to-cart failed', err);
        }
        /* saveDesign already shows/hides its own overlay frame; re-show ours
           so the rest of the flow (cart submit) stays covered. */
        if (overlay) overlay.show('Adding to cart…');
      }

      /* Inject engraving design properties if saved (and not shipping blank) */
      var eng = window.__EI_ENGRAVING__;
      if (!shipBlank && eng && eng.designPng) {
        var pngInput    = form.querySelector('[data-engrave-prop-png]');
        var mockupInput = form.querySelector('[data-engrave-prop-mockup]');
        var svgInput    = form.querySelector('[data-engrave-prop-svg]');
        var jsonInput   = form.querySelector('[data-engrave-prop-json]');
        var labelInput  = form.querySelector('[data-engrave-prop-label]');
        if (pngInput)    pngInput.value    = eng.designPng    || '';
        if (mockupInput) mockupInput.value = eng.designMockup || '';
        if (svgInput)    svgInput.value    = eng.designSvg    || '';
        if (jsonInput)   jsonInput.value   = eng.designJson   || '';
        if (labelInput)  labelInput.value  = eng.label || 'Custom engraving';
      }

      /* Wait for any in-flight inspiration uploads to settle, then populate
         the hidden Inspiration props from window.__EI_INSPIRATION__. */
      try {
        if (window.__EI_INSPIRATION_PENDING__) {
          await window.__EI_INSPIRATION_PENDING__;
        }
      } catch (_) { /* upload errors are surfaced inline; don't block submit */ }
      var inspirationUrls = (window.__EI_INSPIRATION__ && window.__EI_INSPIRATION__[form.dataset.engraveScope]) || [];
      for (var i = 0; i < 5; i++) {
        var slot = form.querySelector('[data-inspiration-prop-' + (i + 1) + ']');
        if (slot) slot.value = inspirationUrls[i] || '';
      }

      var formData = new FormData(form);

      /* Remove empty hidden design fields so they don't clutter the cart */
      if (shipBlank || !eng || !eng.designPng) {
        formData.delete('properties[_Design PNG]');
        formData.delete('properties[_Design Mockup PNG]');
        formData.delete('properties[_Design SVG]');
        formData.delete('properties[_Design JSON]');
        formData.delete('properties[Design]');
      }
      /* Drop empty optional notes / inspiration props so the cart stays tidy */
      ['Custom Design Notes', 'Designer Message', '_Inspiration 1', '_Inspiration 2', '_Inspiration 3', '_Inspiration 4', '_Inspiration 5'].forEach(function(k) {
        if (!formData.get('properties[' + k + ']')) formData.delete('properties[' + k + ']');
      });
      /* Ship Blank checkbox: only keep when checked */
      if (!shipBlank) formData.delete('properties[Ship Blank]');

      var btn = form.querySelector('.ei-product__add-btn');
      var origText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      /* include bundled section rendering so the drawer can update */
      formData.append('sections', 'cart-ajax');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (btn) { btn.textContent = 'Added!'; }

        /* fire ajaxProduct:added with sections data so the drawer updates */
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: data }
        }));

        /* auto-close drawer after delay */
        setTimeout(function() {
          document.dispatchEvent(new CustomEvent('cart:close'));
        }, 3000);

        setTimeout(function() {
          if (btn) { btn.textContent = origText; btn.disabled = false; }
        }, 1500);

        if (overlay) overlay.hide();
      })
      .catch(function(err) {
        console.error('[EI] add-to-cart failed', err);
        if (btn) { btn.textContent = origText; btn.disabled = false; }
        if (overlay) overlay.hide();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ei-split-featured"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-sf-section]');
    if (!section) return;

    var giftWrap = section.querySelector('[data-sf-track="gift"]').parentElement;
    var b2bWrap = section.querySelector('[data-sf-track="b2b"]').parentElement;
    var giftTrack = section.querySelector('[data-sf-track="gift"]');
    var b2bTrack = section.querySelector('[data-sf-track="b2b"]');
    var prevBtn = section.querySelector('[data-sf-prev]');
    var nextBtn = section.querySelector('[data-sf-next]');

    if (!giftTrack || !b2bTrack) return;

    var page = 0;

    function getMaxPage(wrap, track) {
      var containerW = wrap.offsetWidth;
      var trackW = track.scrollWidth;
      if (containerW >= trackW) return 0;
      return Math.ceil((trackW - containerW) / containerW);
    }

    function update() {
      var giftContainerW = giftWrap.offsetWidth;
      var b2bContainerW = b2bWrap.offsetWidth;
      var giftMax = getMaxPage(giftWrap, giftTrack);
      var b2bMax = getMaxPage(b2bWrap, b2bTrack);
      var overallMax = Math.max(giftMax, b2bMax);

      var giftPage = Math.min(page, giftMax);
      var b2bPage = Math.min(page, b2bMax);

      var giftShift = giftPage * (giftContainerW + 16);
      var b2bShift = b2bPage * (b2bContainerW + 16);

      /* clamp so we don't overshoot */
      var giftMaxShift = giftTrack.scrollWidth - giftContainerW;
      var b2bMaxShift = b2bTrack.scrollWidth - b2bContainerW;

      giftTrack.style.transform = 'translateX(-' + Math.min(giftShift, Math.max(0, giftMaxShift)) + 'px)';
      b2bTrack.style.transform = 'translateX(-' + Math.min(b2bShift, Math.max(0, b2bMaxShift)) + 'px)';

      if (prevBtn) prevBtn.disabled = page <= 0;
      if (nextBtn) nextBtn.disabled = page >= overallMax;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (page > 0) { page--; update(); }
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var overallMax = Math.max(getMaxPage(giftWrap, giftTrack), getMaxPage(b2bWrap, b2bTrack));
        if (page < overallMax) { page++; update(); }
      });
    }

    /* thumbnail clicks */
    section.addEventListener('click', function (e) {
      var thumb = e.target.closest('.sf__card-thumb');
      if (!thumb) return;
      e.preventDefault();
      e.stopPropagation();
      var card = thumb.closest('.sf__card');
      if (!card) return;
      var idx = parseInt(thumb.dataset.thumbIdx, 10);
      card.querySelectorAll('.sf__card-mainimg').forEach(function (img) {
        img.style.opacity = parseInt(img.dataset.imgIdx, 10) === idx ? '1' : '0';
      });
      card.querySelectorAll('.sf__card-thumb').forEach(function (t) {
        if (parseInt(t.dataset.thumbIdx, 10) === idx) {
          t.classList.add('is-active');
        } else {
          t.classList.remove('is-active');
        }
      });
    });

    window.addEventListener('resize', function () { update(); });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();
})();
